import { fork } from "redux-saga/effects";
import { eventChannel, END } from 'redux-saga';
import { createChannel } from './helpers';
import WS from '../../websockets-api.js';
import { setPaymentRequest, socketPaymentSubscriber, updateTransactions } from "../actions";
import { fetchPaymentRequest } from "./app";

export function* sailsWebSocketConnections({uuid}){
    yield fork(fetchPaymentRequest, uuid);

    const event = () => eventChannel(emit => {
        const handler = socket => {
            console.log("connect!");
            emit(socketPaymentSubscriber(uuid));
        }

        WS.CONNECT(handler);
        return () => console.log('socket ended');
    });

    yield fork(createChannel, event);
}

export function* paymentRequestSubscriber({uuid}) {
    const event = () => eventChannel(emit => {
        const handler = async (data) => {
            if(data.paymentRequest) {
                emit(setPaymentRequest(data.paymentRequest));
            }

            if(data.cryptoTransaction) {
                emit(updateTransactions(data.cryptoTransaction));
            }
        }
        const errorHandler = error => emit(END);
        WS.subscribe({uuid}, handler, errorHandler);
        WS.ON('paymentRequest', handler, errorHandler);
        WS.ON('cryptoTransaction', handler, errorHandler);

        return () => {
          return console.log(`Subscribe to payment request ended`);
        }
    });
    yield fork(createChannel, event);
}